import { Button } from "../../ui/buttons/button";
import { Loader2, FileDown } from "../../ui/icons";

interface ActionButtonsProps {
  isGenerating: boolean;
  /** false enquanto faltam Marcações para o escopo escolhido. */
  canGenerate: boolean;
  projectName: string;
  onGenerate: () => void;
}

export function ActionButtons({
  isGenerating,
  canGenerate,
  projectName,
  onGenerate,
}: ActionButtonsProps) {
  return (
    <div className="mt-4">
      <Button
        onClick={onGenerate}
        variant="default"
        className="w-full"
        disabled={isGenerating || !canGenerate || !projectName.trim()}
      >
        {isGenerating ? (
          <>
            <Loader2 size={16} className="animate-spin" />
            Gerando Relatório...
          </>
        ) : (
          <>
            Gerar Relatório
            <FileDown size={16} />
          </>
        )}
      </Button>
    </div>
  );
}
